export default {
  todayAppointment: 'Today\'s Appointments',
  person: 'Person',
  receptionDesk: 'Reception Desk',
  queue: 'Queue',
  selectRoom: 'Select Room Display'
}
